import type { KrokWToku } from "../../lib/wynikUzytkownika.js";
import { IconPtaszek } from "../icons/index.js";
import { Spinner } from "../ui/Spinner.js";

/**
 * Trzy proste kroki oceny w toku (zamiast torow etapow technicznych z widoku administratora): zrobiony ma ptaszek,
 * biezacy spinner, oczekujacy pusty kolko. Stan nie jest tylko kolorem: kazdy krok ma tez slowo dla czytnika ekranu
 * ("gotowe", "w toku", "czeka"), a biezacy jest dodatkowo pogrubiony (ST-3, A-7).
 */
const SLOWO_STANU: Readonly<Record<KrokWToku["stan"], string>> = {
  zrobione: "gotowe",
  "w-toku": "w toku",
  oczekuje: "czeka",
};

export function KrokiWToku({ kroki }: { kroki: readonly KrokWToku[] }): React.JSX.Element {
  return (
    <ol className="wynik-kroki" aria-label="Postęp oceny">
      {kroki.map((k) => (
        <li className="wynik-krok" data-stan={k.stan} key={k.id} aria-current={k.stan === "w-toku" ? "step" : undefined}>
          <span className="wynik-krok__ikona" aria-hidden="true">
            {k.stan === "zrobione" ? <IconPtaszek size={14} /> : k.stan === "w-toku" ? <Spinner rozmiar="s" /> : null}
          </span>
          <span className="wynik-krok__tekst">
            {k.tekst}
            <span className="tylko-dla-czytnika">{` - ${SLOWO_STANU[k.stan]}`}</span>
          </span>
        </li>
      ))}
    </ol>
  );
}
